import { createFileRoute } from '@tanstack/react-router'
import { Medications } from '@/features/medications'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/medications/')({
  beforeLoad: requireAdmin,
  component: Medications,
})
